(function () {
  var selector = [
    '.accordion > details',
    'details.wubs-pdp-side__special-item',
    'details.wubs-coll-filters__group'
  ].join(',');

  var duration = 300;
  var easing = 'cubic-bezier(.22, .61, .36, 1)';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function clearAnimation(details) {
    if (details._wubsAccordionAnimation) {
      details._wubsAccordionAnimation.cancel();
      details._wubsAccordionAnimation = null;
    }
  }

  function getClosedHeight(details) {
    var summary = details.querySelector(':scope > summary');
    return summary ? summary.offsetHeight : 0;
  }

  function finish(details, open) {
    details.style.height = '';
    details.style.overflow = '';
    details.classList.remove('is-wubs-accordion-opening', 'is-wubs-accordion-closing');
    details._wubsAccordionAnimation = null;
    details._wubsAccordionTargetOpen = open;

    if (!open) {
      details.open = false;
    }

    var summary = details.querySelector(':scope > summary');
    if (summary) {
      summary.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  }

  function setOpen(details, open) {
    if (!details || !details.matches(selector)) return;

    details._wubsAccordionTargetOpen = open;
    clearAnimation(details);

    if (prefersReducedMotion()) {
      details.open = open;
      finish(details, open);
      return;
    }

    var startHeight = details.open ? details.offsetHeight : getClosedHeight(details);
    details.open = true;
    details.style.overflow = 'hidden';
    details.style.height = startHeight + 'px';

    var endHeight = open ? details.scrollHeight : getClosedHeight(details);

    details.classList.toggle('is-wubs-accordion-opening', open);
    details.classList.toggle('is-wubs-accordion-closing', !open);

    var summary = details.querySelector(':scope > summary');
    if (summary) {
      summary.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    details._wubsAccordionAnimation = details.animate(
      { height: [startHeight + 'px', endHeight + 'px'] },
      { duration: duration, easing: easing }
    );

    details._wubsAccordionAnimation.onfinish = function () {
      finish(details, open);
    };

    details._wubsAccordionAnimation.oncancel = function () {
      details._wubsAccordionAnimation = null;
    };
  }

  function toggle(details) {
    setOpen(details, !(details._wubsAccordionTargetOpen ?? details.open));
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll(selector).forEach(function (details) {
      if (details.dataset.wubsAccordionAnimated === 'true') return;

      var summary = details.querySelector(':scope > summary');
      if (!summary) return;

      details.dataset.wubsAccordionAnimated = 'true';
      details._wubsAccordionTargetOpen = details.open;
      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');

      function stopAccordionEvent(event) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) {
          event.stopImmediatePropagation();
        }
      }

      summary.addEventListener('click', function (event) {
        stopAccordionEvent(event);
        toggle(details);
      }, true);
    });
  }

  window.WubsAccordions = {
    init: init,
    setOpen: setOpen
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
